export default __webpack_public_path__ + "static/media/cancel.01e47350.svg";